import ParositasAdatlapDto from 'app/admin/parositasadatlap/dto/ParositasAdatlapDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class ParositasAdatlapTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'vizsgazoAdatlapParositasTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, ParositasAdatlapDto)))
				.catch(reject);
		});
	}
}

export default new ParositasAdatlapTableService();
